module.exports = __webpack_public_path__ + "c5be3d81f0d9e4e66073ac7e28338a46.svg";